export const accessParam = (path: string, index: number, separator = "/") => {
  return path.split(separator).filter(el => el)[index]
}
